import animationData from '@/static/pet/puppyKitten.json';
import { useLottie } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import { useRef } from 'react';
import styled from 'styled-components';

const AnimationContainer = styled.div`
  width: 100%;
  height: 100%;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 493px;
        height: 362px;
    `}

  & > div {
    width: 100%;
    height: 100%;
  }
`;

export const PuppyKittenAnimation: React.FC = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  useLottie(ref, {
    animationData,
    lottieConfig: {
      autoplay: true,
      loop: true,
    },
  });

  return (
    <AnimationContainer>
      <div ref={ref} />
    </AnimationContainer>
  );
};
